import { Stack, Typography } from '@vapor/material'
import { ReservationF } from '../../../../types/reservation-detail.types'
import CreateDeposit from './create-deposit/create-deposit'
import { faWallet } from '@fortawesome/free-solid-svg-icons'
import { HiCIcon } from 'src/app/components/icons/icon'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export type DepositsActionsProps = {
  propertyId: string
  reservation: ReservationF
  title: string
  readOnly: boolean
}

export default function DepositsActions({ propertyId, reservation, title, readOnly }: DepositsActionsProps) {
  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <HiCIcon>
        <FontAwesomeIcon icon={faWallet} fontSize="1.25rem" />
      </HiCIcon>
      <Typography variant="titleSmall">{title}</Typography>
      <span style={{ marginLeft: 'auto' }}>
        <CreateDeposit reservation={reservation} propertyId={propertyId} disabled={reservation.reservationState.canceled || readOnly} />
      </span>
    </Stack>
  )
}
